import axios from "axios";
import { getToken } from "../services/Auth";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(async (config) => {
  document.getElementById("loader")?.classList?.add("loader");
  const token = await getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    document.getElementById("loader")?.classList?.remove("loader");
    return response;
  },
  (error) => {
    document.getElementById("loader")?.classList?.remove("loader");
    return Promise.reject(error?.response?.data || {});
  },
);

export default api;

export const api_url_estabelecimentos_image = `${process.env.REACT_APP_STATIC_URL}/estabelecimentos/`;
export const api_url_tipos_image = `${process.env.REACT_APP_STATIC_URL}/estabelecimentos/tipos/`;
export const api_url_promocoes_image = `${process.env.REACT_APP_STATIC_URL}/estabelecimentos/promocoes/`;
